import { defineMessages } from "react-intl";

export const pluginDetailsChannelsCardMessages = defineMessages({
  noChannelsSubtitle: {
    id: "Aeq79M",
    defaultMessage: "Plugin’s settings are set common across all channels",
    description: "PluginDetailsChannelsCard no channels subtitle",
  },
});
